module.exports = __webpack_public_path__ + "img/login-bg-v2.c252c68a.png";